import React from 'react'
import { useController, useFormContext } from 'react-hook-form'

import { ToolConfig } from 'data/hooks/agents/types'
import { useWorkflows } from 'data/hooks/workflows/workflows'

import { Field } from 'ui/components/Field'
import { Select, SelectOption } from 'ui/components/Select'

import { ConfigureToolProps } from './types'

function filterWorkflows(workflows: WorkflowDto[]): WorkflowDto[] {
    return workflows.filter((workflow) => {
        if (!workflow.is_enabled) return false

        const trigger = workflow.trigger
        if (!trigger) return false
        if (trigger.trigger_type !== 'invoked') return false

        return true
    })
}

export function ConfigureRunWorkflowTool({}: ConfigureToolProps) {
    const { data: flows } = useWorkflows()
    const { control } = useFormContext<ToolConfig>()

    const { field, fieldState } = useController({
        name: 'supplied_settings.workflow_sid',
        control,
        rules: {
            required: 'Workflow is required',
        },
    })
    const workflowSid = typeof field.value === 'string' ? field.value : ''

    const workflowOptions = React.useMemo(() => {
        if (!flows) return []

        return filterWorkflows(flows).map((workflow) => ({
            label: workflow.name,
            value: workflow._sid,
        }))
    }, [flows])

    return (
        <Field
            label="Workflow to run"
            helperText={fieldState.error?.message}
            isError={!!fieldState.error}
        >
            <Select
                value={workflowSid}
                onChange={(value) => field.onChange(value)}
                placeholder="Choose a workflow to run"
            >
                {workflowOptions.map((option) => (
                    <SelectOption key={option.value} value={option.value} label={option.label} />
                ))}
            </Select>
        </Field>
    )
}
